export enum DiscountTypeEnum {
  PERCENT = "PERCENT",
  FIXED = "FIXED",
}
